/* ⚛ REACT */
import { useState } from "react";

/* 📦 LIBS */
import { useNavigate } from "react-router";

/* 🧩 COMPONENTS */
import { ItemContainer } from "./components";

import { useTranslation } from "react-i18next";

/* 🧠 REDUX */
import { useSelector } from "react-redux/es/hooks/useSelector";

/* 📁 ASSETS*/
import { BackIcon, ControlIcon, DashIcon, FuncIcon, MaintenanceIcon, MapIcon, OpenIcon, ReportIcon, AdmIcon,
    AlocationIcon, EquipamentIcon, GraficosIcon, CompararIcon, 
    CenterMobile, Menu} from "../../../../Assets/icons/MenuIcons";

/* 🎨 STYLES */
import { Container, SvgIcon, ExpandedContent, SubitensContainer, ContainerCenter } from "./styles";

function MenuButton() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const currentPage = window.location.pathname;
    const [isExpanded, setExpanded] = useState(false);
    const [itenstoShow, setItenstoShow] = useState([]);
    const [showSubitens, setShowsubitens] = useState(false);
    const equipamento = useSelector(state => state.generalReducer.Equipament);
    const user = useSelector(state => state.userReducer);

    const toggleExpanded = () => {
        setExpanded(!isExpanded);
    };

    const ToggleSubitens = (subItens) =>{
        setItenstoShow(subItens)
        setShowsubitens(!showSubitens)
    }

    const hideSubItens = ()=>{
        setShowsubitens(false);
        setTimeout(function(){
            setItenstoShow([]);
        }, 400)
    }

    const changePage = (page, props)=>{
        setTimeout(function(){
            setItenstoShow([]);
        }, 400)
        setExpanded(false);
        setShowsubitens(false);
        navigate(page, props);
    }


    let Dashboard= [];
    try {
        Dashboard.push(
            {
                text: t("dashboards.sub-items.general.sidebar-title"),
                page: equipamento ? `/dashboard/${equipamento}` : `/dashboard`,
                locationFunction : () => {
                    equipamento? navigate(`/dashboard/${equipamento}`) : navigate(`/dashboard`);
                }
            }
        )
        if(user?.user?.can?.includes('loss_control.sanep')){
        Dashboard.push(
            {
                text: t("dashboards.sub-items.loss-control.sidebar-title"),
                page: '/dashboard/perdas',
                locationFunction : () => {
                    navigate('/dashboard/perdas');
                }
            }
        )}     
    } catch (error) {
        
    }

    let Administrativo = []
    // Adiciona os itens conforme as permissões
    // necessário alterar no menu
    try {
        if(user?.user?.can?.includes('user.view')){
            Administrativo.push(
                {
                    icon: FuncIcon,
                    text: t("administrative.sub-items.employees.sidebar-title"),
                    page: '/adm/funcionarios',
                    locationFunction: ()=> {changePage('/adm/funcionarios')}
                }
            )
        }
        if(user?.user?.can?.includes('equipment.view')){
            Administrativo.push(
                {
                    icon: EquipamentIcon,
                    text: t("administrative.sub-items.equipments.sidebar-title"),
                    page: '/adm/equipamentos',
                    locationFunction: ()=> {changePage('/adm/equipamentos')}
                }
            )
            Administrativo.push(
                {
                    icon: EquipamentIcon,
                    text: t("administrative.sub-items.groups.sidebar-title"),
                    page: '/adm/grupos',
                    locationFunction: ()=> {changePage('/adm/grupos')}
                }
            )
        }
        if(user?.user?.can?.includes('allocation.view')){
            Administrativo.push(
                {
                    icon: AlocationIcon,
                    text: t("administrative.sub-items.allocations.sidebar-title"),
                    page: '/adm/alocacoes',
                    locationFunction: ()=> {changePage('/adm/alocacoes')}
                }
            )
        }
        if(user?.user?.can?.includes('role.view')){
            Administrativo.push(
                {
                    icon: AdmIcon,
                    text: t("administrative.sub-items.positions.sidebar-title"),
                    page: '/adm/cargos',
                    locationFunction: ()=> {changePage('/adm/cargos')}
                }
            )
        }
        if(user?.user?.can?.includes('log.view')){
            Administrativo.push(
                {
                    icon: AdmIcon,
                    text: t("administrative.sub-items.logs.sidebar-title"),
                    page: '/adm/logs',
                    locationFunction: ()=> {changePage('/adm/logs')}
                }
            )
        }
        if(user?.user?.can?.includes('permission.index')){
            Administrativo.push(
                {
                    icon: AdmIcon,
                    text: t("administrative.sub-items.permissions.sidebar-title"),
                    page: '/adm/permissoes',
                    locationFunction : () => {
                        navigate('/adm/permissoes');
                    }
                }
            )
        }
    } catch (error) {
        
    }

    let Reports = []
    try {
        Reports.push(
            {
                icon: GraficosIcon,
                text: t("reports.sub-items.history.sidebar-title"),
                page: `/historico/${equipamento}`,
                locationFunction: ()=> {changePage(`/historico/${equipamento}`)}
            }
        )
        Reports.push(
            {
                icon: CompararIcon,
                text: t("reports.sub-items.charts.sidebar-title"),
                page: '/historico/graphs',
                locationFunction : ()=>{changePage(`/historico/graphs`)}
            }
        )
    } catch (error) {
        
    }

    let Maintenances = []
    try {
        if(user?.user?.can?.includes('maintenance.view')){
            Maintenances.push(
                {
                    icon: MaintenanceIcon,
                    text: 'Listagem',
                    page: '/manutencoes',
                    locationFunction: ()=> {changePage('/manutencoes')}
                }
            )
            Maintenances.push(
                {
                    icon: ReportIcon,
                    text: 'Relatórios',
                    page: '/manutencoes/report',
                    locationFunction: ()=> {changePage('/manutencoes/report')}
                }
            )

        }
    } catch (error) {
        
    }


    return (
        <>
            <Container $isExpanded={isExpanded} onClick={toggleExpanded}>
                <SvgIcon src={Menu}/>
            </Container>

            <ExpandedContent $show={isExpanded}>
                <ItemContainer icon={ControlIcon} select={currentPage.includes('/controle')} active={true} text={'Controle'} 
                    ClickFunction={()=> equipamento? changePage(`/controle/${equipamento}`) : changePage(`/controle`)}
                    page={equipamento ? `/controle/${equipamento}` : `/controle`}/>
                <ItemContainer icon={ReportIcon} active={true} text={'Relatórios'}  disabled={false}
                    select={currentPage.includes('/historico')}
                    ClickFunction={()=>ToggleSubitens(Reports)}
                />
                <ItemContainer icon={MaintenanceIcon} select={currentPage.includes('/manutencoes')} 
                    active={user?.user?.can?.includes('maintenance.view')} text={'Manutenções'} 
                    disabled={true} ClickFunction={()=>ToggleSubitens(Maintenances)}
                />

                <ItemContainer icon={DashIcon} active={true} text={'Dashboard'} select={currentPage.includes('/dashboard')}
                    ClickFunction={()=>ToggleSubitens(Dashboard)}
                />

                {/* <ItemContainer icon={DashIcon} active={true} text={'Dashboard'} select={currentPage.includes('/dashboard')}
                    ClickFunction={()=> equipamento? changePage(`/dashboard/${equipamento}`) : changePage(`/dashboard`)} page={'/dashboard'}/> */}

                <ItemContainer disabled={true} active={true}>
                    <ContainerCenter src={CenterMobile}/>   
                </ItemContainer>
                <ItemContainer icon={AdmIcon} active={Administrativo.length > 0} text={'Administrativo'} disabled={Administrativo.length < 0}
                    select={currentPage.includes('/funcionarios') || currentPage.includes('/equipamentos')
                    || currentPage.includes('/alocacoes') || currentPage.includes('/grupos') || currentPage.includes('/logs')}
                    ClickFunction={()=>ToggleSubitens(Administrativo)}
                />

                <ItemContainer icon={MapIcon} active={true} select={currentPage === '/'} text={'Mapa'} ClickFunction={()=> changePage('/')} page={'/'}/>
                <ItemContainer icon={OpenIcon} active={false} text={'Irís'} disabled={true}/>
                <ItemContainer icon={BackIcon} active={true} text={''} ClickFunction={toggleExpanded}/>
            </ExpandedContent>

            <SubitensContainer $show={showSubitens}>
                {itenstoShow.map((item, index)=>{
                    return(
                        <ItemContainer select={false} key={index} icon={item.icon} text={item.text} ClickFunction={item.locationFunction} active={true} page={item.page}/>
                    )
                })}
                {showSubitens?
                    <ItemContainer icon={BackIcon} text={''} ClickFunction={hideSubItens} active={true}/>
                :
                    <></>
                }
            </SubitensContainer>
        </>
    );
}

export default MenuButton;
